
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"14","viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.128 0l15.997 16.092-2.127 2.115L1 2.115 3.128 0z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.959 16.039L17.051.04l2.115 2.128L3.074 18.166.959 16.04z","fill":"#fff"}})])
          )
        }
      }
    